export default __webpack_public_path__ + "static/media/AuditStatement.51e7c595.png";